// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pending-fee-overlay {
  --pf-ink: #1f1b2e;
  --pf-muted: #55515f;
  --pf-soft: #6f7588;
  --pf-mint: #bff1db;
  --pf-peach: #f9e1be;
  --pf-lavender: #d5d1fd;
  --pf-pink: #f2c4c4;
  --pf-panel: #f7f6fa;
  --pf-surface: #ffffff;
  --pf-line: rgba(31, 27, 46, 0.1);
  --pf-radius: 20px;

  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(18, 16, 26, 0.48);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.pending-fee-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 1120px);
  height: min(92vh, 840px);
  max-height: min(92vh, 840px);
  margin: auto;
  background: var(--pf-surface);
  color: var(--pf-ink);
  border: 1px solid var(--pf-line);
  border-radius: var(--pf-radius);
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.24);
  overflow: hidden;
}

.pending-fee-dialog__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.6rem 1.05rem;
  border-bottom: 1px solid var(--pf-line);
  flex-shrink: 0;
  background: var(--pf-surface);
}

.pending-fee-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--pf-muted);
}

.pending-fee-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.4rem, 2.3vw, 1.75rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--pf-ink);
}

.pending-fee-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: var(--pf-panel);
  color: var(--pf-ink);
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.pending-fee-dialog__close:hover {
  background: #ebe8f2;
}

.pending-fee-dialog__layout {
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(0, 1.25fr);
  flex: 1 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  align-items: stretch;
}

.pending-fee-aside {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  padding: 1.25rem 1.25rem 1.35rem;
  background: var(--pf-surface);
  border-right: 1px solid var(--pf-line);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
}

.pending-fee-aside__amount-label {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--pf-soft);
}

.pending-fee-aside__amount {
  margin: 0.35rem 0 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.85rem, 3vw, 2.25rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--pf-ink);
}

.pending-fee-aside__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.65rem;
}

.pending-fee-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.28rem 0.7rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  background: var(--pf-lavender);
  border: 1px solid transparent;
  color: #3a3560;
}

.pending-fee-pill--status {
  background: var(--pf-pink);
  color: #5a3030;
}

.pending-fee-pill--due.pending-fee-pill--calm {
  background: var(--pf-lavender);
  color: #3a3560;
}

.pending-fee-pill--due.pending-fee-pill--warn {
  background: var(--pf-peach);
  color: #5a4020;
}

.pending-fee-pill--due.pending-fee-pill--urgent {
  background: #f2c4c4;
  color: #5a3030;
}

.pending-fee-pill--due.pending-fee-pill--critical {
  background: #e8a0a0;
  color: #4a2020;
}

.pending-fee-pill--due.pending-fee-pill--neutral {
  background: var(--pf-panel);
  color: var(--pf-muted);
}

.pending-fee-next-step {
  padding: 0.85rem 0.95rem 0.9rem;
  border-radius: 12px;
  background: rgba(249, 225, 190, 0.38);
  border: 1px solid rgba(249, 225, 190, 0.9);
  border-left: 3px solid #d4a15c;
}

.pending-fee-next-step--warn {
  background: rgba(249, 225, 190, 0.5);
  border-color: rgba(212, 161, 92, 0.55);
  border-left-color: #c48a3a;
}

.pending-fee-next-step--urgent {
  background: rgba(242, 196, 196, 0.42);
  border-color: rgba(200, 120, 120, 0.55);
  border-left-color: #b85c5c;
}

.pending-fee-next-step--urgent .pending-fee-next-step__label,
.pending-fee-next-step--critical .pending-fee-next-step__label {
  color: #5a3030;
}

.pending-fee-next-step--critical {
  background: rgba(232, 160, 160, 0.45);
  border-color: rgba(180, 90, 90, 0.55);
  border-left-color: #9a3a3a;
}

.pending-fee-next-step__label {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6a5230;
}

.pending-fee-next-step__copy {
  margin: 0;
  font-size: 0.96rem;
  line-height: 1.5;
  font-weight: 600;
  color: var(--pf-ink);
}

.pending-fee-next-step__copy strong {
  font-weight: 800;
}

.pending-fee-upload-card {
  margin-top: 0.15rem;
  flex-shrink: 0;
  padding: 1.05rem 1.05rem 1.1rem;
  border-radius: 14px;
  background: var(--pf-panel);
  border: 1px solid var(--pf-line);
}

.pending-fee-upload-card__title {
  margin: 0 0 0.3rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--pf-ink);
}

.pending-fee-upload-card__hint {
  margin: 0 0 0.9rem;
  font-size: 0.82rem;
  line-height: 1.45;
  color: var(--pf-muted);
}

.pending-fee-upload__label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.pending-fee-upload__input {
  width: 100%;
  padding: 0.7rem 0.8rem;
  border-radius: 10px;
  border: 1px solid rgba(143, 155, 175, 0.28);
  background: var(--pf-surface);
  color: var(--pf-ink);
  font-size: 0.88rem;
  margin-bottom: 0.7rem;
}

.pending-fee-upload__input:focus {
  outline: 2px solid rgba(31, 27, 46, 0.25);
  outline-offset: 1px;
}

.pending-fee-upload__btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(180, 120, 40, 0.35);
  border-radius: 10px;
  background: var(--pf-peach);
  color: #5a4020;
  font-weight: 750;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.pending-fee-upload__btn:hover:not(:disabled) {
  background: #f9e1be;
  border-color: rgba(180, 120, 40, 0.55);
}

.pending-fee-upload__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pending-fee-upload__filename {
  margin: 0.55rem 0 0;
  font-size: 0.8rem;
  color: #3f4558;
  word-break: break-all;
}

.pending-fee-upload-card__note {
  margin: 0.75rem 0 0;
  font-size: 0.78rem;
  line-height: 1.4;
  color: var(--pf-soft);
}

.pending-fee-main {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  padding: 1.25rem 1.45rem 1.75rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
  background: var(--pf-surface);
}

.pending-fee-block__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.pending-fee-block__title {
  margin: 0;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--pf-soft);
}

.pending-fee-block__count {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--pf-soft);
}

.pending-fee-rows {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.pending-fee-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 1rem;
  padding: 0.95rem 1.05rem 0.95rem 1.15rem;
  border-radius: 12px;
  background: rgba(249, 225, 190, 0.28);
  border: 1px solid rgba(249, 225, 190, 0.65);
  overflow: hidden;
}

.pending-fee-row--with-months {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.7rem;
}

.pending-fee-row__top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 1rem;
}

.pending-fee-row--static .pending-fee-row__top {
  grid-template-columns: minmax(0, 1fr) auto;
}

.pending-fee-month-split {
  list-style: none;
  margin: 0;
  padding: 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(31, 27, 46, 0.08);
}

.pending-fee-month-split__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.84rem;
}

.pending-fee-month-split__label {
  color: var(--pf-muted);
  font-weight: 600;
}

.pending-fee-month-split__amt {
  font-weight: 700;
  color: var(--pf-ink);
  white-space: nowrap;
}

.pending-fee-month-split__fallback {
  margin: 0;
  font-size: 0.8rem;
  color: var(--pf-soft);
}

.pending-fee-due-months {
  margin-top: 1.25rem;
  padding-top: 1.15rem;
  border-top: 1px solid var(--pf-line);
}

.pending-fee-due-months__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.pending-fee-due-months__list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  background: var(--pf-panel);
  border: 1px solid var(--pf-line);
  font-size: 0.9rem;
}

.pending-fee-due-months__list li span {
  color: var(--pf-muted);
  font-weight: 600;
}

.pending-fee-due-months__list li strong {
  font-weight: 700;
  color: var(--pf-ink);
  white-space: nowrap;
}

.pending-fee-row::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--pf-peach);
}

.pending-fee-row--enrolled {
  background: rgba(191, 241, 219, 0.28);
  border-color: rgba(191, 241, 219, 0.7);
}

.pending-fee-row--enrolled::before {
  background: var(--pf-mint);
}

.pending-fee-row--static {
  grid-template-columns: minmax(0, 1fr) auto;
}

.pending-fee-row__title {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 650;
  line-height: 1.35;
  color: var(--pf-ink);
  word-break: break-word;
}

.pending-fee-row__fee {
  font-size: 0.98rem;
  font-weight: 700;
  color: #2c3140;
  white-space: nowrap;
}

.pending-fee-row__drop {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.15rem;
  height: 2.15rem;
  border: 1px solid var(--pf-line);
  border-radius: 10px;
  background: var(--pf-surface);
  color: #5a4040;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.pending-fee-row__drop:hover:not(:disabled) {
  background: rgba(242, 196, 196, 0.55);
  border-color: rgba(242, 196, 196, 0.9);
}

.pending-fee-row__drop:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pending-fee-block__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.85rem;
  padding: 0.15rem 0.1rem 0;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--pf-ink);
}

.pending-fee-empty {
  margin: 0;
  padding: 1.05rem 1.1rem;
  border-radius: 12px;
  border: 1px dashed rgba(143, 155, 175, 0.32);
  background: #fbfbfd;
  color: var(--pf-soft);
  font-size: 0.92rem;
}

@media (max-width: 900px) {
  .pending-fee-dialog {
    width: min(100%, 720px);
    height: min(94vh, 900px);
    max-height: min(94vh, 900px);
  }

  .pending-fee-dialog__layout {
    display: flex;
    flex-direction: column;
    grid-template-columns: none;
    grid-template-rows: none;
    align-items: stretch;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
  }

  /* Keep each section at content height so the upload CTA cannot
     shrink/overflow underneath the charged-enrollments panel. */
  .pending-fee-aside,
  .pending-fee-main {
    height: auto;
    max-height: none;
    min-height: min-content;
    flex: 0 0 auto;
    overflow: visible;
  }

  .pending-fee-aside {
    position: relative;
    z-index: 1;
    border-right: none;
    border-bottom: 1px solid var(--pf-line);
  }

  .pending-fee-upload-card {
    position: relative;
    z-index: 2;
  }
}

@media (max-width: 560px) {
  .pending-fee-overlay {
    padding: 0.75rem;
  }

  .pending-fee-dialog {
    height: min(96vh, 900px);
    max-height: min(96vh, 900px);
    border-radius: 16px;
  }

  .pending-fee-dialog__top,
  .pending-fee-aside,
  .pending-fee-main {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PendingFeePopup.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;;EAEjB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,uCAAuC;EACvC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,wBAAwB;EAC1B;;EAEA;gEAC8D;EAC9D;;IAEE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".pending-fee-overlay {\n  --pf-ink: #1f1b2e;\n  --pf-muted: #55515f;\n  --pf-soft: #6f7588;\n  --pf-mint: #bff1db;\n  --pf-peach: #f9e1be;\n  --pf-lavender: #d5d1fd;\n  --pf-pink: #f2c4c4;\n  --pf-panel: #f7f6fa;\n  --pf-surface: #ffffff;\n  --pf-line: rgba(31, 27, 46, 0.1);\n  --pf-radius: 20px;\n\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(18, 16, 26, 0.48);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.pending-fee-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 1120px);\n  height: min(92vh, 840px);\n  max-height: min(92vh, 840px);\n  margin: auto;\n  background: var(--pf-surface);\n  color: var(--pf-ink);\n  border: 1px solid var(--pf-line);\n  border-radius: var(--pf-radius);\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.24);\n  overflow: hidden;\n}\n\n.pending-fee-dialog__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.6rem 1.05rem;\n  border-bottom: 1px solid var(--pf-line);\n  flex-shrink: 0;\n  background: var(--pf-surface);\n}\n\n.pending-fee-dialog__eyebrow {\n  margin: 0 0 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--pf-muted);\n}\n\n.pending-fee-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.4rem, 2.3vw, 1.75rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--pf-ink);\n}\n\n.pending-fee-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: var(--pf-panel);\n  color: var(--pf-ink);\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.pending-fee-dialog__close:hover {\n  background: #ebe8f2;\n}\n\n.pending-fee-dialog__layout {\n  display: grid;\n  grid-template-columns: minmax(260px, 0.9fr) minmax(0, 1.25fr);\n  flex: 1 1 0%;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n  align-items: stretch;\n}\n\n.pending-fee-aside {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  padding: 1.25rem 1.25rem 1.35rem;\n  background: var(--pf-surface);\n  border-right: 1px solid var(--pf-line);\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-gutter: stable;\n}\n\n.pending-fee-aside__amount-label {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--pf-soft);\n}\n\n.pending-fee-aside__amount {\n  margin: 0.35rem 0 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.85rem, 3vw, 2.25rem);\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  color: var(--pf-ink);\n}\n\n.pending-fee-aside__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-top: 0.65rem;\n}\n\n.pending-fee-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.28rem 0.7rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  background: var(--pf-lavender);\n  border: 1px solid transparent;\n  color: #3a3560;\n}\n\n.pending-fee-pill--status {\n  background: var(--pf-pink);\n  color: #5a3030;\n}\n\n.pending-fee-pill--due.pending-fee-pill--calm {\n  background: var(--pf-lavender);\n  color: #3a3560;\n}\n\n.pending-fee-pill--due.pending-fee-pill--warn {\n  background: var(--pf-peach);\n  color: #5a4020;\n}\n\n.pending-fee-pill--due.pending-fee-pill--urgent {\n  background: #f2c4c4;\n  color: #5a3030;\n}\n\n.pending-fee-pill--due.pending-fee-pill--critical {\n  background: #e8a0a0;\n  color: #4a2020;\n}\n\n.pending-fee-pill--due.pending-fee-pill--neutral {\n  background: var(--pf-panel);\n  color: var(--pf-muted);\n}\n\n.pending-fee-next-step {\n  padding: 0.85rem 0.95rem 0.9rem;\n  border-radius: 12px;\n  background: rgba(249, 225, 190, 0.38);\n  border: 1px solid rgba(249, 225, 190, 0.9);\n  border-left: 3px solid #d4a15c;\n}\n\n.pending-fee-next-step--warn {\n  background: rgba(249, 225, 190, 0.5);\n  border-color: rgba(212, 161, 92, 0.55);\n  border-left-color: #c48a3a;\n}\n\n.pending-fee-next-step--urgent {\n  background: rgba(242, 196, 196, 0.42);\n  border-color: rgba(200, 120, 120, 0.55);\n  border-left-color: #b85c5c;\n}\n\n.pending-fee-next-step--urgent .pending-fee-next-step__label,\n.pending-fee-next-step--critical .pending-fee-next-step__label {\n  color: #5a3030;\n}\n\n.pending-fee-next-step--critical {\n  background: rgba(232, 160, 160, 0.45);\n  border-color: rgba(180, 90, 90, 0.55);\n  border-left-color: #9a3a3a;\n}\n\n.pending-fee-next-step__label {\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #6a5230;\n}\n\n.pending-fee-next-step__copy {\n  margin: 0;\n  font-size: 0.96rem;\n  line-height: 1.5;\n  font-weight: 600;\n  color: var(--pf-ink);\n}\n\n.pending-fee-next-step__copy strong {\n  font-weight: 800;\n}\n\n.pending-fee-upload-card {\n  margin-top: 0.15rem;\n  flex-shrink: 0;\n  padding: 1.05rem 1.05rem 1.1rem;\n  border-radius: 14px;\n  background: var(--pf-panel);\n  border: 1px solid var(--pf-line);\n}\n\n.pending-fee-upload-card__title {\n  margin: 0 0 0.3rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--pf-ink);\n}\n\n.pending-fee-upload-card__hint {\n  margin: 0 0 0.9rem;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: var(--pf-muted);\n}\n\n.pending-fee-upload__label {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.pending-fee-upload__input {\n  width: 100%;\n  padding: 0.7rem 0.8rem;\n  border-radius: 10px;\n  border: 1px solid rgba(143, 155, 175, 0.28);\n  background: var(--pf-surface);\n  color: var(--pf-ink);\n  font-size: 0.88rem;\n  margin-bottom: 0.7rem;\n}\n\n.pending-fee-upload__input:focus {\n  outline: 2px solid rgba(31, 27, 46, 0.25);\n  outline-offset: 1px;\n}\n\n.pending-fee-upload__btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid rgba(180, 120, 40, 0.35);\n  border-radius: 10px;\n  background: var(--pf-peach);\n  color: #5a4020;\n  font-weight: 750;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.pending-fee-upload__btn:hover:not(:disabled) {\n  background: #f9e1be;\n  border-color: rgba(180, 120, 40, 0.55);\n}\n\n.pending-fee-upload__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pending-fee-upload__filename {\n  margin: 0.55rem 0 0;\n  font-size: 0.8rem;\n  color: #3f4558;\n  word-break: break-all;\n}\n\n.pending-fee-upload-card__note {\n  margin: 0.75rem 0 0;\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: var(--pf-soft);\n}\n\n.pending-fee-main {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  padding: 1.25rem 1.45rem 1.75rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-gutter: stable;\n  background: var(--pf-surface);\n}\n\n.pending-fee-block__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.pending-fee-block__title {\n  margin: 0;\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--pf-soft);\n}\n\n.pending-fee-block__count {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--pf-soft);\n}\n\n.pending-fee-rows {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.pending-fee-row {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.95rem 1.05rem 0.95rem 1.15rem;\n  border-radius: 12px;\n  background: rgba(249, 225, 190, 0.28);\n  border: 1px solid rgba(249, 225, 190, 0.65);\n  overflow: hidden;\n}\n\n.pending-fee-row--with-months {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.7rem;\n}\n\n.pending-fee-row__top {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 1rem;\n}\n\n.pending-fee-row--static .pending-fee-row__top {\n  grid-template-columns: minmax(0, 1fr) auto;\n}\n\n.pending-fee-month-split {\n  list-style: none;\n  margin: 0;\n  padding: 0.55rem 0.65rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px solid rgba(31, 27, 46, 0.08);\n}\n\n.pending-fee-month-split__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-size: 0.84rem;\n}\n\n.pending-fee-month-split__label {\n  color: var(--pf-muted);\n  font-weight: 600;\n}\n\n.pending-fee-month-split__amt {\n  font-weight: 700;\n  color: var(--pf-ink);\n  white-space: nowrap;\n}\n\n.pending-fee-month-split__fallback {\n  margin: 0;\n  font-size: 0.8rem;\n  color: var(--pf-soft);\n}\n\n.pending-fee-due-months {\n  margin-top: 1.25rem;\n  padding-top: 1.15rem;\n  border-top: 1px solid var(--pf-line);\n}\n\n.pending-fee-due-months__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.pending-fee-due-months__list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 10px;\n  background: var(--pf-panel);\n  border: 1px solid var(--pf-line);\n  font-size: 0.9rem;\n}\n\n.pending-fee-due-months__list li span {\n  color: var(--pf-muted);\n  font-weight: 600;\n}\n\n.pending-fee-due-months__list li strong {\n  font-weight: 700;\n  color: var(--pf-ink);\n  white-space: nowrap;\n}\n\n.pending-fee-row::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: var(--pf-peach);\n}\n\n.pending-fee-row--enrolled {\n  background: rgba(191, 241, 219, 0.28);\n  border-color: rgba(191, 241, 219, 0.7);\n}\n\n.pending-fee-row--enrolled::before {\n  background: var(--pf-mint);\n}\n\n.pending-fee-row--static {\n  grid-template-columns: minmax(0, 1fr) auto;\n}\n\n.pending-fee-row__title {\n  margin: 0;\n  font-size: 1.02rem;\n  font-weight: 650;\n  line-height: 1.35;\n  color: var(--pf-ink);\n  word-break: break-word;\n}\n\n.pending-fee-row__fee {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: #2c3140;\n  white-space: nowrap;\n}\n\n.pending-fee-row__drop {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.15rem;\n  height: 2.15rem;\n  border: 1px solid var(--pf-line);\n  border-radius: 10px;\n  background: var(--pf-surface);\n  color: #5a4040;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.pending-fee-row__drop:hover:not(:disabled) {\n  background: rgba(242, 196, 196, 0.55);\n  border-color: rgba(242, 196, 196, 0.9);\n}\n\n.pending-fee-row__drop:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pending-fee-block__footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.85rem;\n  padding: 0.15rem 0.1rem 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--pf-ink);\n}\n\n.pending-fee-empty {\n  margin: 0;\n  padding: 1.05rem 1.1rem;\n  border-radius: 12px;\n  border: 1px dashed rgba(143, 155, 175, 0.32);\n  background: #fbfbfd;\n  color: var(--pf-soft);\n  font-size: 0.92rem;\n}\n\n@media (max-width: 900px) {\n  .pending-fee-dialog {\n    width: min(100%, 720px);\n    height: min(94vh, 900px);\n    max-height: min(94vh, 900px);\n  }\n\n  .pending-fee-dialog__layout {\n    display: flex;\n    flex-direction: column;\n    grid-template-columns: none;\n    grid-template-rows: none;\n    align-items: stretch;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-gutter: stable;\n  }\n\n  /* Keep each section at content height so the upload CTA cannot\n     shrink/overflow underneath the charged-enrollments panel. */\n  .pending-fee-aside,\n  .pending-fee-main {\n    height: auto;\n    max-height: none;\n    min-height: min-content;\n    flex: 0 0 auto;\n    overflow: visible;\n  }\n\n  .pending-fee-aside {\n    position: relative;\n    z-index: 1;\n    border-right: none;\n    border-bottom: 1px solid var(--pf-line);\n  }\n\n  .pending-fee-upload-card {\n    position: relative;\n    z-index: 2;\n  }\n}\n\n@media (max-width: 560px) {\n  .pending-fee-overlay {\n    padding: 0.75rem;\n  }\n\n  .pending-fee-dialog {\n    height: min(96vh, 900px);\n    max-height: min(96vh, 900px);\n    border-radius: 16px;\n  }\n\n  .pending-fee-dialog__top,\n  .pending-fee-aside,\n  .pending-fee-main {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
